import * as React from 'react';

export const CollaboratorModalFooterContext = React.createContext<{
  setFooter: (node: React.ReactNode) => void;
} | null>(null);
